/**
 * @desc: - 选择投注mode
 * @param  {[NUMBER]} currentNum:     [当前选号注数]
 * @param  {[STRING]} currentMoney:   [当前投注金额]
 * @param  {[NUMBER]} totalOrderNum:  [总单数]
 * @param  {[STRING]} totalBetNum:    [总注数]
 * @param  {[STRING]} totalMoney:     [总金额]
 * @param  {[FUNCTION]} addFn:        [总金额]
 * @param  {[FUNCTION]} BetFn:        [总金额]
 * @author: ammo
 */
import { connect } from 'react-redux'
import Loader from '../../../components/icon/Loader.jsx';

export class AddBets extends React.Component {

  constructor(props) {
    super(props);
    this.handleWinnerNotice = this.handleWinnerNotice.bind(this)
  }

  // 切换中奖通知
  handleWinnerNotice() {
    const __base = this.props.__BASE.toJS();
    const { startWinnerNotice, stopWinnerNotice } = this.props.$$BASE;
    __base.config.winnerNotice ? stopWinnerNotice() : startWinnerNotice()
  }

  render() {
    const __base = this.props.__BASE.toJS();
    const { currentNum, currentMoney, totalOrderNum, totalBetNum, totalMoney } = this.props;
    const { addFn, BetFn, windowId, openTrack } = this.props;
    const __window = this.props.__METHOD.toJS().windows[windowId];
    return (
        <div className='min-chooseMsg'>
            <p onClick={addFn.bind(this, true)} className={(currentNum && currentNum > 0) ? 'onekeyBet pointer addBetbtn' : "oneKeyBtnDefault"} >一键投注</p>
            <p onClick={addFn.bind(this, false)} className={(currentNum && currentNum > 0) ? 'addBtn pointer addBetbtn' : "addBetbtn addBtnDefault"}>+&nbsp;&nbsp;添加号码</p>
            {/*<p onClick={addFn.bind(this, true)} className={(currentNum && currentNum > 0) ? 'onekeyBet pointer lightning' : "lightning"}>立即投注</p>*/}
        </div>
    );
  }
}

reactMixin(AddBets.prototype, ImmutableMixin);

function mapStateToProps(state) {
  return {
    __METHOD: state.method,
    __BASE: state.base
  }
}

function mapDispatchToProps(dispatch) {
  return {
    $$LOTTERY: bindActionCreators(lotteryAction, dispatch),
    $$BASE: bindActionCreators(baseAction, dispatch)
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddBets)